import React from "react";
import { Row, Col } from "react-bootstrap";

function PaymentMtdCard({
  setShowAddNewPaymentMethod,
  paymentMethodLoading,
  activePaymentMethod,
}) {
  console.log(activePaymentMethod);
  return (
    <Row className="m-0">
      <Col md="16" lg="14" xl="12" xxl="10" className=" ps-0">
        <div
          className="p-4 border rounded bg-white mb-5"
          style={{ boxShadow: "rgba(0, 123, 255, 0.2) 0px 3px 8px" }}
        >
          {!paymentMethodLoading && (
            <div className="p-3">
              <div>
                <h3 className="mb-3">{activePaymentMethod.cardInfo.brand}</h3>
                <h3 className="mb-3">
                  **** **** **** {activePaymentMethod.cardInfo.last4}
                </h3>
                <h4 className="d-flex align-items-center justify-content-between">
                  <div>{activePaymentMethod.name}</div>
                  <div>
                    {activePaymentMethod.cardInfo.exp_month > 9
                      ? activePaymentMethod.cardInfo.exp_month
                      : `0${activePaymentMethod.cardInfo.exp_month}`}
                    <strong>/</strong>
                    {activePaymentMethod.cardInfo.exp_year}
                  </div>
                </h4>
              </div>
              <button
                onClick={() => {
                  setShowAddNewPaymentMethod(true);
                }}
                className="btn btn-primary mt-5"
              >
                Change Card
              </button>
            </div>
          )}
          {paymentMethodLoading && (
            <div>
              <div className="text-center">
                <button className="btn loading-btn p-0" type="button">
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Loading Your Payment Method
                </button>
              </div>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
}

export default PaymentMtdCard;
